import { render, staticRenderFns } from "./WorkflowsEfficiency.vue?vue&type=template&id=ceba27a4"
import script from "./WorkflowsEfficiency.vue?vue&type=script&lang=js"
export * from "./WorkflowsEfficiency.vue?vue&type=script&lang=js"
import style0 from "./WorkflowsEfficiency.vue?vue&type=style&index=0&id=ceba27a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports